import * as React from 'react';
import { CaptionLinkTypography, CaptionTypography } from 'ui';

type Props = {
	linkText?: string;
	buttonText: string;
	onClick: (e: React.MouseEvent<HTMLElement>) => void;
};

export const LinkButton: React.FC<Props> = ({ linkText, buttonText, onClick }) => {
	return (
		<div className="flex flex-row gap-[4px]" data-testid="auth-link-button">
			{linkText && <CaptionTypography className="text-primary">{linkText}</CaptionTypography>}
			<CaptionLinkTypography
				className="text-primary active:text-gray hover:cursor-pointer hover:no-underline active:no-underline"
				onClick={onClick}
				data-testid="auth-link-button-action"
			>
				{buttonText}
			</CaptionLinkTypography>
		</div>
	);
};
